import script from "./BrandListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandListItem.vue?vue&type=script&setup=true&lang=js"

import "./BrandListItem.vue?vue&type=style&index=0&id=2b525f50&lang=scss"
import "./BrandListItem.vue?vue&type=style&index=1&id=2b525f50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b525f50"]])

export default __exports__